import { z } from 'zod'

export const ADMINRUNTIMEGET_CONTRACT_VERSION = '1.0.0' as const
export const adminRuntimeGetResponseSchema = z.unknown()
export type AdminRuntimeGetResponse = z.infer<typeof adminRuntimeGetResponseSchema>
